<template>
    <div class="service-card">
        <div class="card-icon">
            <i :class="icon"></i>
        </div>
        <h3 class="card-title">{{ title }}</h3>
        <p class="card-description">{{ description }}</p>
        <div class="card-hover-overlay">
            <i :class="icon"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServiceCard',
    props: {
        icon: String,
        title: String,
        description: String
    }
}
</script>

<style scoped>
.service-card {
    background: #1a1d29;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 35px 30px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.service-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff6b6b, #ff8787);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s ease;
}

.service-card:hover {
    background: #212430;
    border-color: rgba(255, 107, 107, 0.3);
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.service-card:hover::before {
    transform: scaleX(1);
}

.card-icon {
    width: 60px;
    height: 60px;
    background: rgba(255, 107, 107, 0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    transition: all 0.3s ease;
}

.service-card:hover .card-icon {
    background: rgba(255, 107, 107, 0.2);
    transform: scale(1.1);
}

.card-icon i {
    font-size: 28px;
    color: #ff6b6b;
}

.card-title {
    font-size: 22px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 15px 0;
    line-height: 1.3;
}

.card-description {
    font-size: 15px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

.card-hover-overlay {
    position: absolute;
    top: -50px;
    right: -50px;
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.03;
    pointer-events: none;
}

.card-hover-overlay i {
    font-size: 120px;
    color: #fff;
}

/* Responsive */
@media (max-width: 768px) {
    .service-card {
        padding: 28px 24px;
    }

    .card-icon {
        width: 55px;
        height: 55px;
    }

    .card-icon i {
        font-size: 24px;
    }

    .card-title {
        font-size: 20px;
    }

    .card-description {
        font-size: 14px;
    }
}
</style>
